import { AdminType, APIGet, APIUrl } from "api/protocols";
import { CancelToken } from "axios";




export async function GetGuestGiftCardBalance(
    params: {code: string; pin: string},
    useGlobalLoader: boolean,
    token?: CancelToken,
  ) {
    return await APIGet<number>(APIUrl(AdminType.Guest, "/gift-card"), params, useGlobalLoader, token);
  }